export const DEFAULT_TITLE = 'Select Delivery Location';
export const BUTTON_TEXT = 'Apply';
export const BUTTON_STATE = {
  APPLY: 'Apply',
  CLEAR: 'Clear',
  EDIT: 'Edit',
};
export const DELIVERY_HEADING = 'Select Delivery Location';
export const DELIVERY_TEXT =
  'Enter the pincode of your area to check product availability and delivery options';
export const PINCODE_PLACEHOLDER = '122001';
export const DO_NOT_SERVICE_AT_YOUR_LOCATION = 'Unfortunately, we do not service your location';
export const PINCODE_ERROR_TEXT = "Sorry, we're temporarily unable to deliver here";
export const VALID_PINCODE_TEXT = 'Please enter a valid pincode';
